import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const WasteModuleGate = () => {
    const navigate = useNavigate();
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            minHeight: '40vh', textAlign: 'center', padding: '40px 20px',
        }}>
            <div style={{
                width: 64, height: 64, borderRadius: '50%', backgroundColor: '#F4F5FE',
                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24,
            }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#0B1157" strokeWidth="1.8">
                    <rect x="3" y="11" width="18" height="11" rx="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
            </div>
            <h5 style={{ color: '#0B1157', fontWeight: 700, marginBottom: 8 }}>Odpadový modul nie je aktivovaný</h5>
            <p style={{ color: '#718094', fontSize: 14, maxWidth: 360, marginBottom: 24, lineHeight: 1.6 }}>
                Modul Evidencia odpadov nie je súčasťou vášho predplatného.
                Aktivujte demo zadarmo alebo si vyberte platený plán.
            </p>
            <Button className="btn-custom-small px-4" onClick={() => navigate('/billing')}>
                Aktivovať Evidenciu odpadov
            </Button>
        </div>
    );
};

export default WasteModuleGate;
